"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { cn } from "../../lib/utils";
import { EllipsisTooltip } from "../EllipsisTooltip/EllipsisTooltip";
import { ScopeIcon } from "../ScopeIcon/ScopeIcon";
import type { PageTitleProps } from "./PageTitle.types";
export const PageTitle: FC<PageTitleProps> = t0 => {
  const $ = _c(14);
  const {
    title,
    scopeType,
    className,
    trailing,
    collapseWhitespace
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex min-w-0 flex-1 items-center gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== scopeType) {
    t2 = <ScopeIcon type={scopeType} size="md" className="hidden md:flex" />;
    $[2] = scopeType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== collapseWhitespace || $[5] !== title) {
    t3 = <EllipsisTooltip content={title} placement="bottom" color="foreground" className="min-w-0 font-semibold text-2xl" as="h1" collapseWhitespace={collapseWhitespace}>{title}</EllipsisTooltip>;
    $[4] = collapseWhitespace;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3 || $[8] !== trailing) {
    t4 = <div className="flex min-w-0 items-center gap-2">{t3}{trailing}</div>;
    $[7] = t3;
    $[8] = trailing;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};